export const PRIORITIES = ['HIGH', 'MEDIUM', 'LOW'];
export const PRIORITIES_OPTIONS = [
  { label: 'High', value: 'HIGH' },
  { label: 'Medium', value: 'MEDIUM' },
  { label: 'Low', value: 'LOW' },
];

export const EXCEED_HOURS_ERROR_MESSAGE =
  'The project is over the estimated time';
